export enum DeviceAuthOption {
  ANONYMOUS = "ANONYMOUS",
  USER_LOGIN = "USER_LOGIN",
  CLIENT_CERTIFICATE = "CLIENT_CERTIFICATE",
}

export const deviceAuthTabOptions = Object.values(DeviceAuthOption);